export const zh = {
    "SuccessfullySaved": "保存成功",
    "SuccessfullyDeleted": "删除成功"
}